import { BadgeModel } from '@sosocio/creator/interfaces';
import ApiService from 'services/ApiService';

class BadgeService extends ApiService<BadgeModel> {
	constructor() {
		super('badge');
	}
}

export default new BadgeService();
